import React from "react";
import Modal from "react-modal";

function RegistrationPaymentFailureModal(props) {
  const { bulkFailedPayments, onClose, show } = props;

  return (
    <Modal isOpen={show} className="modal-container">
      <div className="card small-modal trip-modal">
        <div className="large-text mb-8">Payment Declined</div>
        <div className="accent-text-dark mb-8">
          The{" "}
          {bulkFailedPayments
            ? "following student(s)' cards were"
            : "student's card was"}{" "}
          declined. We've sent them an email with instructions to update their
          payment information. They have been marked pending and will
          automatically be charged and accepted once they update their payment
          method.
          {bulkFailedPayments?.map((p, i) => (
            <div className={`mt-${i ? 4 : 8}`} key={p.registrationID}>
              {p.studentName}
            </div>
          ))}
        </div>
        <div className="modal-btns">
          <button className="link-text uppercase-text" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(RegistrationPaymentFailureModal);
